export const STATUSES = [
    {
        id: 0,
        title: 'ACTIVE',
    },
    {
        id: 1,
        title: 'BLOCKED',
    },
    {
        id: 2,
        title: 'RESERVED',
    },
    {
        id: 3,
        title: 'ARCHIVED',
    },
    {
        id: 4,
        title: 'ON_VACATION',
    },
    {
        id: 5,
        title: 'NOT_CONFIRMED',
    },
    {
        id: 6,
        title: 'CANDIDATE',
    },
    {
        id: 7,
        title: 'GRADUATE',
    },
    {
        id: 8,
        title: 'PROMO',
    },
];

export const USER_STATUSES = [
    {
        id: 0,
        title: 'ACTIVE',
    },
    {
        id: 1,
        title: 'BLOCKED',
    },
    {
        id: 2,
        title: 'RESERVED',
    },
    {
        id: 3,
        title: 'ARCHIVED',
    },
    {
        id: 4,
        title: 'ON_VACATION',
    },
    // {
    //     id: 5,
    //     title: 'NOT_CONFIRMED',
    // },
    {
        id: 6,
        title: 'CANDIDATE',
    },
    {
        id: 7,
        title: 'GRADUATE',
    },
    {
        id: 8,
        title: 'PROMO',
    },
];

export const CANDIDATE_STATUSES = [
    {
        id: 6,
        title: 'CANDIDATE',
        disabled: true,
    },
    {
        id: 3,
        title: 'ARCHIVED',
    },
    {
        id: 2,
        title: 'RESERVED',
    },
];

export const ACTIVE_STATUSES = [
    {
        id: 0,
        title: 'ACTIVE',
        disabled: true,
    },
    {
        id: 1,
        title: 'BLOCKED',
    },
    {
        id: 4,
        title: 'ON_VACATION',
    },
    {
        id: 7,
        title: 'GRADUATE',
    },
    {
        id: 3,
        title: 'ARCHIVED',
    },
    {
        id: 2,
        title: 'RESERVED',
    },
];

export const BLOCKED_STATUSES = [
    {
        id: 1,
        title: 'BLOCKED',
        disabled: true,
    },
    {
        id: 0,
        title: 'ACTIVE',
    },
    {
        id: 4,
        title: 'ON_VACATION',
    },
    {
        id: 7,
        title: 'GRADUATE',
    },
    {
        id: 3,
        title: 'ARCHIVED',
    },
    {
        id: 2,
        title: 'RESERVED',
    },
];

export const VACATION_STATUSES = [
    {
        id: 4,
        title: 'ON_VACATION',
        disabled: true,
    },
    {
        id: 0,
        title: 'ACTIVE',
    },
    {
        id: 1,
        title: 'BLOCKED',
    },
    {
        id: 7,
        title: 'GRADUATE',
    },
    {
        id: 3,
        title: 'ARCHIVED',
    },
    {
        id: 2,
        title: 'RESERVED',
    },
];

export const RESERVE_STATUSES = [
    {
        id: 2,
        title: 'RESERVED',
        disabled: true,
    },
    {
        id: 3,
        title: 'ARCHIVED',
    },
    {
        id: 6,
        title: 'CANDIDATE',
    },
];

const ARCHIVE_STATUSES = [
    {
        id: 3,
        title: 'ARCHIVED',
        disabled: true,
    },
    {
        id: 2,
        title: 'RESERVED',
    },
    {
        id: 6,
        title: 'CANDIDATE',
    },
];

export const GRADUATE_STATUSES = [
    {
        id: 7,
        title: 'GRADUATE',
        disabled: true,
    },
    {
        id: 0,
        title: 'ACTIVE',
    },
];

export const PROMO_STATUSES = [
    {
        id: 8,
        title: 'PROMO',
        disabled: true,
    },
    {
        id: 0,
        title: 'ACTIVE',
    },
    {
        id: 1,
        title: 'BLOCKED',
    },
    {
        id: 4,
        title: 'ON_VACATION',
    },
    {
        id: 6,
        title: 'CANDIDATE',
    },
    {
        id: 7,
        title: 'GRADUATE',
    },
    {
        id: 3,
        title: 'ARCHIVED',
    },
    {
        id: 2,
        title: 'RESERVED',
    },
];

export const RESTRICTED_STATUSES_SCHEMA = {
    0: ACTIVE_STATUSES,
    1: BLOCKED_STATUSES,
    2: RESERVE_STATUSES,
    3: ARCHIVE_STATUSES,
    4: VACATION_STATUSES,
    5: USER_STATUSES, //not confirmed
    6: CANDIDATE_STATUSES,
    7: GRADUATE_STATUSES,
    8: PROMO_STATUSES,
};

export const USER_STATUSES_TEACHER = [
    {
        id: 0,
        title: 'ACTIVE',
    },
    {
        id: 1,
        title: 'BLOCKED',
    },
];

export const ACTIVE_GROUP_CANDIDATE_STATUSES = [
    {
        id: 6,
        title: 'CANDIDATE',
        disabled: true,
    },
    {
        id: 0,
        title: 'ACTIVE',
    },
    {
        id: 3,
        title: 'ARCHIVED',
    },
    {
        id: 2,
        title: 'RESERVED',
    },
];

export const QUIZ_STATUSES_SELECT = [
    { id: null, title: 'news.selectStatus' },
    {
        id: 0,
        title: 'quiz.notPublished',
    },
    {
        id: 1,
        title: 'quiz.published',
    },
];

export const QUIZ_DISABLED = [
    { id: null, title: 'news.selectStatus' },
    { id: 0, title: 'table.yes' },
    { id: 1, title: 'table.no' },
];
export const QUIZ_STATUSES_MOBILE = [
    {
        id: 0,
        title: 'quiz.notPublished',
    },
    {
        id: 1,
        title: 'quiz.published',
    },
];

export const STATUS_MAP = {
    0: 'ACTIVE',
    1: 'BLOCKED',
    2: 'RESERVED',
    3: 'ARCHIVED',
    4: 'ON_VACATION',
    5: 'NOT_CONFIRMED',
    6: 'CANDIDATE',
    7: 'GRADUATE',
    8: 'PROMO',
};
